<script setup>
  import Setup from './Setup.vue';  
  import { ref, computed } from 'vue';
  import {useDesignLabStore} from "../DesignLabStore.js"
  import ValidInput from "../ValidInput.vue"

  const designLabStore = useDesignLabStore();
  const toInputNewName = computed(() => designLabStore.designNeedReplace || designLabStore.isNewDesign)
  const tempDesignName = ref(""); // new design name
  const validField = ref(null); // ValidInput expose

  const canSubmit = computed(() => {
    if (toInputNewName.value) return tempDesignName.value && validField?.value?.validate();
    else return designLabStore.validDesignName;
  })

  const saveDesign = async ()=> {
    if (toInputNewName.value) designLabStore.design.name = tempDesignName.value

    const err = await designLabStore.saveDesign();

    if (!err) {
      designLabStore.goToNextSetup();
    }
  }
</script>

<template>
  <Setup title="命名設計">
    <template #content>
    <div class="mx-auto w-75 mt-5">

      <div class="text-center">
        <div v-if="designLabStore.isNewDesign">
          <h3>為你的設計命名吧！</h3>
        </div>

        <div v-if="!designLabStore.isNewDesign">
          <h3>儲存你的設計</h3>

          <div class="w-50 mx-auto mt-4 text-center">
            <div class="form-check">
              <input class="form-check-input form-check-input-mk" type="radio" id="dr-radio-one" name="design-replace-radio" value="1" v-model="designLabStore.designReplaceRadioCache" />
              <label class="form-check-label text-break text-start" for="dr-radio-one">
                覆蓋 {{ designLabStore.designNameCache }}
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input form-check-input-mk" type="radio" id="dr-radio-two" name="design-replace-radio" value="2" v-model="designLabStore.designReplaceRadioCache" /> 
              <label class="form-check-label" for="dr-radio-two">
                輸入新的名稱
              </label>
            </div>
          </div>

        </div>
      </div>

      <ValidInput
        v-if="toInputNewName"
        v-model:value="tempDesignName"
        ref="validField"
        name="designName"
        type="plainText"
        class="mt-4"
        placeholder="我的設計"
        :required="true"
        :maxlength="15"
      />

      <div class="d-flex justify-content-center mt-4">
        <button class="mk-btn" @click="saveDesign()" title="確認送出" :disabled="!canSubmit">確認送出</button>
      </div>

    </div>
    </template>
  </Setup>
</template>